export const DEEP_LINKS_REDIRECT_ORIGIN = 'https://g.camp';
